import React, { useEffect, useState } from 'react';
import { FIELD_NAME, FORM_SUBMIT_STATUS } from '../../../constants/form-constants';
import { formService } from '../../../form-service';
import { TextInputExtended } from './core/text-input-extended';

interface Props {
	label?: string;
	required?: boolean;
}

const CIF_REGEXP = /^[ABCDEFGHJNPQRSUVW]\d{7}[0-9A-J]$/i;

// CIF completo y válido.
export function isCifComplete(value: string): boolean {
	return CIF_REGEXP.test(value);
}

// El valor, aunque esté incompleto, encaja con el formato de un CIF (vamos por buen camino).
export function isCifOnTrack(value: string): boolean {
	if (value.length > 9) return false;
	return [...value].every((char, index) => {
		if (index === 0) return /[ABCDEFGHJNPQRSUVW]/i.test(char);
		if (index === 8) return /[0-9A-J]/i.test(char);
		return /\d/.test(char);
	});
}

export function CifInput(props: Props) {
	const { required } = props;
	const [hasError, setHasError] = useState(false);

	// Mientras escribe: solo hay error si el valor ya no puede llegar a ser un CIF válido.
	const handleChange = (value: string) => {
		setHasError(value.length > 0 && !isCifOnTrack(value));
	};

	// Al salir del campo: si ha escrito algo, exigimos un CIF completo y válido.
	const handleBlur = (value: string) => {
		setHasError(value.length > 0 && !isCifComplete(value));
	};

	// Al intentar enviar, marcamos error si el campo requerido está vacío o el CIF no es válido.
	useEffect(() => {
		const unsubscribe = formService.subscribeToFormSubmitStatus((status) => {
			if (status !== FORM_SUBMIT_STATUS.INVALID) return;
			const value = formService.getFieldValue<string>(FIELD_NAME.CIF) || '';
			setHasError((required || value.length > 0) && !isCifComplete(value));
		});
		return unsubscribe;
	}, [required]);

	return (
		<TextInputExtended
			{...props}
			label={props.label || 'CIF'}
			name={FIELD_NAME.CIF}
			maxLength={9}
			validate={isCifComplete}
			hasError={hasError}
			errorMessage="CIF incorrecto"
			onChange={(e: any) => {
				e.target.value = e.target.value.toUpperCase();
				handleChange(e.target.value);
			}}
			onBlur={(e: any) => handleBlur(e.target.value.toUpperCase())}
		/>
	);
}
